const withImportMap = (importMaps: any, userName: string): string | null => {

    userName = userName.trim().toLowerCase()

    if (importMaps.usersByName[userName])   return importMaps.usersByName[userName]
    if (importMaps.usersByEmail[userName])  return importMaps.usersByEmail[userName]

    return null
}

// old should not be used
const withoutImportMap = (userName: string): string | null => {
    const companyUsers = gd.session.companyUsers

    if (companyUsers) {
        const searchValue: string = userName.trim().toLowerCase()
        const companyUser = _.find(companyUsers.models,companyUser=>
            companyUser.user.name.toLowerCase().trim() === searchValue
        )

        if (companyUser) return companyUser.user.id
    }

    return null
}



export default function mapByUserName(companyId: string, userName: string): string | null {
    // @ts-ignore
    if (gd.getApp().maps) {
        // @ts-ignore
        return withImportMap(gd.getApp().maps, userName)
    } else {
        return withoutImportMap(userName)
    }
}
